<template>
    <div>
        <v-container grid-list-xs fluid>
            <v-card>
                <dynamic-toolbar title="Driver Files Management System" :loading="loading.lists" color="indigo" icon="mdi-note-search"
                    theme="dark">
                </dynamic-toolbar>
                <v-container grid-list-xs fluid>
                    <v-row>
                        <v-col cols="1">
                            <v-combobox v-model="region" :items="regions" :item-text="'PrincipalRegion'"
                                :item-value="'PrincipalRegionID'" label="Select Region"
                                :rules="[v => !!v || 'Region is Required']" auto-select-first dense hide-details
                                required></v-combobox>
                        </v-col>
                        <v-col cols="2">
                            <v-form ref="form" v-model="valid" lazy-validation>
                                <v-combobox v-model="driver" :items="active == true ? drivers : driversInactive" :item-text="'Name'" :item-value="'id'"
                                    auto-select-first label="Select a Driver" hide-details dense 
                                    @change="getDocumentByDriver" @click:prepend="active = !active;"  
                                    :prepend-icon="active == true ? 'mdi-toggle-switch-outline' : 'mdi-toggle-switch-off-outline'"></v-combobox>
                            </v-form>
                        </v-col>
                        <v-col cols="3" v-if="driver.id != undefined">
                            <v-row>
                                <v-col cols="6">
                                    <v-combobox v-model="main" :items="all" :item-text="'MainCategory'"
                                        :item-value="'MainCatId'" auto-select-first label="Select a Main Category"
                                        hide-details dense></v-combobox>
                                </v-col>
                                <v-col cols="6" v-if="main.subcategory != undefined">
                                    <v-combobox v-model="sub" :items="main.subcategory" :item-text="'SubCategory'"
                                        :item-value="'SubCatId'" auto-select-first label="Select a SubCategory"
                                        append-icon="mdi-close" @click:append-icon="main.subcategory = undefined"
                                        hide-details dense></v-combobox>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="2">
                            <v-row align="center" justify="space-around">
                                <v-btn @click="downloadZip" class="mt-2" color="red" text><v-icon
                                        class="mr-2">mdi-download-circle-outline</v-icon> Download</v-btn>
                                <v-btn @click="clearFilters" class="mt-2" color="secondary" text><v-icon
                                        class="mr-2">mdi-brush-variant</v-icon> Clear</v-btn>
                            </v-row>
                        </v-col>
                        <v-col>

                            <span class="float-right mt-2"> Update Files</span>
                            <v-file-input class="float-right" hide-input v-model="docs" multiple dense hide-details
                                @change="addFiles"></v-file-input>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-bottom-navigation :value="navPosition" color="primary" dense>
                                <v-btn @click="filterCat(2, 0)">
                                    <span>Payroll</span>

                                    <v-icon>mdi-account-credit-card</v-icon>
                                </v-btn>
                                <v-btn @click="filterCat(1, 1)">
                                    <span>Human Resources</span>
                                    <v-icon>mdi-human-capacity-increase</v-icon>
                                </v-btn>

                                <v-btn @click="filterCat(3, 2)">
                                    <span>Operations</span>

                                    <v-icon>mdi-cog-sync</v-icon>
                                </v-btn>

                                <v-btn @click="filterCat(4, 3)">
                                    <span>Safety and Comppliance</span>

                                    <v-icon>mdi-seatbelt</v-icon>
                                </v-btn>

                                <v-btn @click="filterCat(5, 4)">
                                    <span>HSSE </span>
                                    <v-icon>mdi-train-bus</v-icon>
                                </v-btn>
                                <v-btn @click="filterCat(6, 5)">
                                    <span>Safety-Admin</span>
                                    <v-icon>mdi-security</v-icon>
                                </v-btn>
                                <v-btn @click="filterCat(7, 5)">
                                    <span>Others</span>
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                </v-btn>
                                <v-btn v-if="OOTruckShow" @click="navPosition = 6;">
                                    <span>OOTrucks </span>
                                    <v-icon>mdi-tanker-truck</v-icon>
                                </v-btn>
                                <!-- <v-btn @click="navPosition = 7;">
                                    <span>Courses </span>
                                    <v-icon>mdi-school</v-icon>
                                </v-btn> -->
                            </v-bottom-navigation>
                        </v-col>
                    </v-row>
                    <v-row v-if="driver != null || driver != ''">
                        <v-toolbar color="primary" dark dense >
                            <v-spacer></v-spacer>
                            <v-toolbar-title>
                                {{ driver.DriverType }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </v-row>
                    <v-row>
                        <v-container grid-list-xs>
                            <pr_documents v-if="show == true && navPosition === 0" :documents="subs">
                            </pr_documents>
                            <hr_documents v-if="show == true && navPosition === 1" :documents="subs">
                            </hr_documents>
                            <op_documents v-if="show == true && navPosition === 2" :documents="subs">
                            </op_documents>
                            <sc_documents v-if="show == true && navPosition === 3" :documents="subs" :driver="driver">
                            </sc_documents>
                            <hsse_documents v-if="show == true && navPosition === 4" :documents="subs">
                            </hsse_documents>
                            <sa_documents v-if="show == true && navPosition === 5" :documents="subs">
                            </sa_documents>
                            <oo_trucks v-if="show == true && navPosition == 6" :ootrucks="OOTrucks" :driver="driver.id">
                            </oo_trucks>
                            
                            <driver_courses v-if="show == true && navPosition == 7" :courses="courses" :driver="driver">
                            </driver_courses>
                            
                            <add_documents v-if="showAdd" @close="closeAdd" :show="showAdd" :files="docs"
                                :docTypes="docTypes" :Driver="driver.id" @updateDriver="getDocumentByDriver">
                            </add_documents>
                        </v-container>
                    </v-row>
                </v-container>
            </v-card>
        </v-container>
    </div>
</template>
<script>
function logErr(error) {
    console.log(error);
}
import axios from 'axios';
import DateRangeMenu from '@/components/Global/Utils/DateRangeMenu.vue';
import DynamicToolbar from '../../components/Global/Utils/DynamicToolbar.vue';

import hr_documents from '@/components/HR/DriverList/HRFiles.vue';
import pr_documents from '@/components/HR/DriverList/Payroll.vue';
import op_documents from '@/components/HR/DriverList/Operations.vue';
import oo_trucks from '@/components/HR/DriverList/OOTrucks.vue';
import sc_documents from '@/components/HR/DriverList/SafetyCompliance.vue';
import sa_documents from '@/components/HR/DriverList/SafetyAdmin.vue';
import hsse_documents from '@/components/HR/DriverList/HSSE.vue';
import add_documents from '@/components/HR/DriverList/AddDocuments.vue';
import driver_courses from '@/components/HR/DriverList/Courses.vue';

// import { method } from 'lodash';
export default {
    components: {
        DynamicToolbar,
        DateRangeMenu,
        hr_documents,
        pr_documents,
        op_documents,
        sc_documents,
        sa_documents,
        hsse_documents,
        oo_trucks,
        add_documents,
        driver_courses
    },
    data: () => ({
        loading: {
            lists: false,
            cost: false,
            dateRangeTotalCost: false,
            totalCostByType: false,
            totalCostByEquipment: false,
            totalCostByCategory: false,
            totalCostBySubcategory: false,
            report: false
        },
        valid:false,
        docs: null,
        show: false,
        OOTruckShow: false,
        OOTrucks: [],
        region: null,
        regions: [],
        hrDocuments: null,
        hrDocumentsNA: null,
        authentication: '',
        navPosition: 1,
        drivers: [],
        driver: '',
        driverdata: [],
        subs: [],
        docTypes: [],
        showAdd: false,
        all: [],
        main: [],
        sub: [],
        driversInactive:[],
        active:true,
        courses: [],
    }),
    methods: {
        closeAdd: function () {
            this.showAdd = false;
            this.docs = false;
        },
        getDrivers() {
            this.loading.lists = true;
            axios
                .get('driver/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.drivers = response.data.data;
                })
                .catch(error => {
                    this.logErr(error);
                })
                .finally(() => {
                    this.loading.lists = false;
                });
        },
        getInActiveDrivers() {
            this.loading.lists = true;
            axios
                .get('driver/inactive', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.driversInactive = response.data.data;
                })
                .catch(error => {
                    this.logErr(error);
                })
                .finally(() => {
                    this.loading.lists = false;
                });
        },
        getCourses() {
            this.loading.lists = true;
            var parms = {
                Driver:  this.driver.id
            }
            axios
                .post('driver-list/driver/courses',parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.courses = response.data;
                })
                .catch(error => {
                    this.logErr(error);
                })
                .finally(() => {
                    this.loading.lists = false;
                });
        },
        getTrucks() {
            this.loading.lists = true;
            this.show = false;
            console.log(this.driver);
            axios
                .get('driver-list/driver/' + this.driver.id, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.OOTrucks = response.data['oo_trucks'];
                })
                .catch(error => {
                    this.logErr(error);
                })
                .finally(() => {
                    this.loading.lists = false;
                    this.show = true;
                });
        },
        filterCat: function (cat, pos) {
            this.navPosition = pos;
            console.log(this.driverdata);
            this.subs = this.driverdata.find(x => {
                return x.MainCatId == cat;
            });
            console.log(this.subs);
        },
        loadCategories: function () {
            var str = this.$store;
            axios
                .get('main-category/all', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.all = response.data;
                    this.dataLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
        },
        clearFilters: function () {
            // this.driver = null;
            this.main = [];
            this.sub = [];
            // this.driverdata = [];
            // this.subs = [];
        },
        getDocumentByDriver() {
            if (this.driver === '' || this.driver === null) {

            } else {
                var parms = {
                    Driver: this.driver.id,
                    DriverType: this.driver.DriverTypeId
                }
                this.loading.lists = true;
                this.show = false;
                axios
                    .post('driver-list/documents',parms, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        // this.getCourses();
                        this.driverdata = response.data;
                        if (this.driver.DriverTypeId == 3 || this.driver.DriverTypeId == 7) {
                            this.OOTruckShow = true;
                            this.getTrucks();
                        }
                        this.driverdata = response.data;
                        this.filterCat(2, 0);
                    })
                    .catch(error => {
                        this.logErr(error);
                    })
                    .finally(() => {
                        this.loading.lists = false;
                        this.show = true;
                    });
            }
        },
        loadRegions: function () {
            this.$store.state.isLoading = true;
            axios
                .get('regions', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.regions = response.data;
                    this.regions.push({ PrincipalRegionID: 5, PrincipalRegion: "All" });
                    this.region = this.regions[3];
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        addFiles: function () {
            console.log(this.docs);
            if(this.driver === null || this.driver === ''){
                this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text:'First select a driver'
                        });
                this.docs = null;
            }else{
                console.log(this.docs);
                this.showAdd = true;
            }
        },
        getDocuments: function () {
            this.loading.lists = true;
            axios
                .get('document', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.docTypes = response.data;
                })
                .catch(error => {
                    this.logErr(error);
                })
                .finally(() => {
                    this.loading.lists = false;
                });
        },
        downloadZip: function () {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                Region: this.region.PrincipalRegionID,
                Driver: this.driver.id == undefined ? undefined : this.driver.id,
                Main: this.main.MainCatId == undefined ? undefined : this.main.MainCatId,
                Sub: this.sub.SubCatId == undefined ? undefined : this.sub.SubCatId,
            }
            axios
                .post('driver-list/zip', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    let name = null;
                    if (this.driver === null || this.driver === '') {
                        name = this.region.PrincipalRegion + ' - Drivers';
                    } else {
                        name = this.driver.Name;
                    }
                    link.setAttribute(
                        'download', name + '.zip'
                    );
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        validate () {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.addFiles();
            }
        },
    },
    mounted() {
        this.authentication = {
            headers: {
                Authorization: 'Bearer ' + this.$store.state.token
            }
        };
        this.getDrivers();
        this.getInActiveDrivers();
        this.loadRegions();
        this.loadCategories();
        // this.getDocuments();
    },
}

</script>